var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#FFEDD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1085 25L21.4419 13.3333C21.2965 13.0769 21.0857 12.8635 20.831 12.7151C20.5762 12.5666 20.2867 12.4884 19.9919 12.4884C19.697 12.4884 19.4075 12.5666 19.1527 12.7151C18.898 12.8635 18.6872 13.0769 18.5419 13.3333L11.8752 25C11.7283 25.2545 11.6512 25.5433 11.6519 25.8371C11.6525 26.1309 11.7308 26.4194 11.8789 26.6732C12.0269 26.927 12.2395 27.1372 12.4949 27.2824C12.7504 27.4276 13.0397 27.5027 13.3335 27.5H26.6669C26.9593 27.4997 27.2465 27.4225 27.4996 27.2761C27.7527 27.1297 27.9629 26.9193 28.1089 26.6659C28.255 26.4126 28.3319 26.1253 28.3318 25.8329C28.3317 25.5405 28.2547 25.2533 28.1085 25Z",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5V20.8333",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24.1667H20.0083",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.1918f51d0abb253d5f48c9bff50608f2.svg";
export { ForwardRef as ReactComponent };